/**
 * Converts timestamp to date in local timezone as string in the format YYYY-MM-DD
 * @param {Date | string | number} date (universal) Timestamp (universal timestamp)
 * @returns {string} date in the format YYYY-MM-DD in local timezone
 */
// eslint-disable-next-line import/prefer-default-export
export const getLocalDate = (date) => {
  const inputDate = new Date(date); // is required by some calls of this function
  const year = inputDate.getFullYear().toString();
  let month = (inputDate.getMonth() + 1).toString();
  if (month.length === 1) month = `0${month}`;
  let day = inputDate.getDate().toString();
  if (day.length === 1) day = `0${day}`;
  return `${year}-${month}-${day}`;
};

/**
 * Creates a (deep) copy of a JavaScript object if it can be represented as JSON object
 * @param {object|string|number|boolean} obj
 * @returns {object|string|number|boolean} copy
 */
export const cp = (obj) => {
  return JSON.parse(JSON.stringify(obj));
};

/**
 * returns a new array without duplicates or null if the function gets null
 * @param {any[] | null} arr
 * @returns {any[] | null}
 */
export const getArrayWithoutDuplicates = (arr) => {
  if (arr === null) return null;
  if (!Array.isArray(arr)) throw new Error('array required');
  const newArr = [];
  arr.forEach((item) => {
    const stringifiedItem = JSON.stringify(item);
    const idx = newArr.findIndex((newArrItem) => {
      return stringifiedItem === JSON.stringify(newArrItem);
    });
    if (idx === -1) newArr.push(item);
  });
  return newArr;
};

/**
 * Parses query parameters from query string
 * @param {string} queryString query parameters string (encoded)
 * @returns {object} parsed query parameters
 */
export const parseQueryParams = (queryString) => {
  if (!queryString) return {};
  try {
    const queryParams = {};
    let queryStringToProcess = queryString;
    if (queryStringToProcess.startsWith('?'))
      queryStringToProcess = queryStringToProcess.substr(1);
    queryStringToProcess.split('&').forEach((item) => {
      const keyVal = item
        .split('=')
        .map((keyValPart) => decodeURIComponent(keyValPart));
      let val;
      try {
        val = keyVal[1].split(',').map((element) => {
          switch (element) {
            case 'true':
              return true;
            case 'false':
              return false;
            case 'null':
              return null;
            default:
              return element;
          }
        });
      } catch (e) {
        // eslint-disable-next-line prefer-destructuring
        val = keyVal[1];
      }
      queryParams[keyVal[0]] = val;
    });
    return queryParams;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    return {};
  }
};

/**
 * creates encoded query parameter string
 * @param {object} params
 * @returns {string} encoded query parameter string
 */
export const encodeQueryParams = (params) => {
  try {
    let queryParameterString = '';
    if (params) {
      queryParameterString = Object.keys(params)
        .map((key) => {
          let val = params[key];
          if (val) {
            if (typeof val === 'object') {
              val = Array.isArray(val)
                ? val.map((item) => `${item}`).join(',')
                : JSON.stringify(val);
            }
            return `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
          }
          return null;
        })
        .join('&');
      queryParameterString = `?${queryParameterString}`;
    }
    return queryParameterString;
  } catch (err) {
    return '';
  }
};
